import { API_URLS } from '@services/apiRoutes'
import { clearsEmptyProperties } from '@utils/functions/clearsEmptyProperties'

import type { AddNewProfileRequestProps, GetProfilesRequestProps, SavePermissionsRequestProps } from './types'

import * as apiFunction from '@services/apiFunctions'

export const deleteProfile = async (profileId: number) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.auth.accessProfile}/${profileId}`,
    method: 'DELETE'
  })
}

export const addNewProfile = async ({ bodyParams }: AddNewProfileRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.auth.accessProfile}`,
    method: 'POST',
    body
  })
}

export const savePermissions = async ({ routeParams, bodyParams }: SavePermissionsRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.auth.permissions}/${routeParams.profileId}`,
    method: 'PUT',
    body
  })
}

export const getAccessProfileById = async (profileId: string) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.auth.permissions}/${profileId}`,
    method: 'GET'
  })
}

export const getProfiles = async ({ bodyParams }: GetProfilesRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.auth.accessProfile}/busca`,
    method: 'POST',
    body
  })
}

// GET sem filtros devolve todos os perfis (sao poucos); aceita lista direta ou { items }
export const getAllProfiles = async (): Promise<{ code: string; name?: string; description?: string }[]> => {
  const response = await apiFunction.apiRequestWithQueryParams({
    url: API_URLS.auth.profilesList,
    method: 'GET'
  })
  return Array.isArray(response) ? response : (response?.items ?? [])
}
